import { useEffect, useRef, useState } from 'react';

// Hook to capture the quadrant heatmap area as a PNG using html2canvas
export function useChartImage(assessmentData: any, maturityResults: any) {
  const [chartImage, setChartImage] = useState<string | null>(null);
  const chartRef = useRef<HTMLDivElement>(null);

  // Primary capture
  useEffect(() => {
    if (chartRef.current && assessmentData && maturityResults) {
      const capture = async () => {
        try {
          const html2canvas = (await import('html2canvas')).default;
          const canvas = await html2canvas(chartRef.current!, {
            backgroundColor: '#FFFFFF',
            scale: 3,
            useCORS: true,
            allowTaint: true,
          });
          setChartImage(canvas.toDataURL('image/png'));
        } catch (err) {
          console.error('Chart capture failed:', err);
        }
      };
      const t = setTimeout(capture, 1500);
      return () => clearTimeout(t);
    }
  }, [assessmentData, maturityResults]);

  // Secondary capture as fallback
  useEffect(() => {
    if (assessmentData && maturityResults && !chartImage) {
      const t = setTimeout(async () => {
        if (!chartRef.current) return;
        try {
          const html2canvas = (await import('html2canvas')).default;
          const canvas = await html2canvas(chartRef.current!, {
            backgroundColor: '#FFFFFF',
            scale: 3,
            useCORS: true,
            allowTaint: true,
          });
          setChartImage(canvas.toDataURL('image/png'));
        } catch (err) {
          console.error('Secondary chart capture failed:', err);
        }
      }, 2000);
      return () => clearTimeout(t);
    }
  }, [assessmentData, maturityResults, chartImage]);

  return { chartRef, chartImage } as const;
}

